import React, { useState, useEffect, useRef } from "react";

import {
  Col,
  Row,
  Divider,
  Input,
  Form,
  Button,
  Card,
  InputNumber,
  Checkbox,
  Modal,
  Select,
  message,
  Layout,
} from "antd";
import Cleave from "cleave.js/react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PosCommissionTable from "../routes/B2B/PosCommissionTable";
import PosSelectableInstallmentTable from "../routes/B2B/PosSelectableInstallmentTable";

import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "../routes/Forms/Helper";
import { ColumnHelper } from "util/TableHelper";
import { useHistory } from "react-router";
import { footerText } from "../util/config";
import Screen from "../util/Extensions/Screens";
import PosCollectionAmountSummary from "../routes/B2B/PosCollectionAmountSummary";
import { useUrlIframeBankIds, emailRequiredBankIds } from "util/B2BHelper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
};
const { TextArea } = Input;
const ConstantPaymentPage = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [creditCardType, setCreditCardType] = useState("");
  const [form] = Form.useForm();
  const [paymentModal, setPaymentModal] = useState({
    visible: false,
    source: null,
  });
  const [availableProviders, setAvailableProviders] = useState({
    loading: true,
    data: [],
  });
  const [availableInstallments, setAvailableInstallments] = useState({
    loading: true,
    data: [1],
  });
  const [activeProviderId, setActiveProviderId] = useState();
  const [currencyCodes, setCurrencyCodes] = useState(["TRY", "USD", "EUR"]);
  const [commissionOptions, setCommissionOptions] = useState({
    loading: true,
    data: {
      useCommissionsForAvailableInstallment: false,
      useFirmGroupCodeForMaxInstallment: false,
      isSelectableInstallmentTable: false,
      posCollectionDescription: null,
      commissions: [],
    },
  });
  const [activeAmount, setActiveAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [radioValue, setRadioValue] = useState();
  const [tenantName, setTenantName] = useState("");
  const iframeRef = useRef();
  const [logoUrl, setLogoUrl] = useState();
  const [tenantPaymentGuid, setTenantPaymentGuid] = useState();
  const [isPaymentWithParams, setIsPaymentWithParams] = useState(false);
  const [disabledAmount, setDisabledAmount] = useState(false);

  const [firmId, setFirmId] = useState("");
  const [posCollectionTransactionId, setPosCollectionTransactionId] =
    useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [siteName, setSiteName] = useState("");
  const [paymentGuid, setPaymentGuid] = useState("");
  const { Footer } = Layout;

  const [confidentialAgreement, setconfidentialAgreement] = useState(
    "/gizlilik-ve-guvenlik-politikasi.pdf"
  );
  const [salesAgreement, setSalesAgreement] = useState("/tuketici-haklari.pdf");

  const [urlIframe, setUrlIframe] = useState(false);
  const [useAdditionalInformation, setUseAdditionalInformation] =
    useState(false);

  const [isUseCreditCardBinCheck, setIsUseCreditCardBinCheck] = useState();
  const [usePosCommissionTable, setUsePosCommissionTable] = useState(false);
  const [
    commissionOptionsForBinCheckUsage,
    setCommissionOptionsForBinCheckUsage,
  ] = useState({
    loading: true,
    data: {
      useCommissionsForAvailableInstallment: false,
      useFirmGroupCodeForMaxInstallment: false,
      isSelectableInstallmentTable: false,
      posCollectionDescription: null,
      commissions: [],
    },
  });
  const [requestBin, setRequestBin] = useState(true);

  const [bankIdFromBinCheckResult, setBankIdFromBinCheckResult] =
    useState(null);
  const [cardKindFromBinCheckResult, setCardKindFromBinCheckResult] =
    useState(null);
  const [activeCommissionRate, setActiveCommissionRate] = useState(0.0);
  const [isUseB2BCurrencyExChange, setIsUseB2BCurrencyExChange] =
    useState(false);

  const [currencyExchangeRates, setCurrencyExchangeRates] = useState({
    data: {
      usdAmount: null,
      euroAmount: null,
      tlAmount: null,
    },
  });
  const [tenantId, setTenantId] = useState("");
  const [activeCurrency, setActiveCurrency] = useState("TRY");
  const [emailRequired, setEmailRequired] = useState(false);
  const [paymentMethodList, setPaymentMethodList] = useState({
    loading: true,
    data: [],
  });
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
  const [
    isUseB2BViewCurrencyExchangeRate,
    setIsUseB2BViewCurrencyExchangeRate,
  ] = useState(false);

  const [viewCurrencyExchangeRates, setViewCurrencyExchangeRates] = useState({
    data: {
      usd: null,
      euro: null,
    },
  });
  const [b2bFilePath, setB2bFilePath] = useState();
  const [tenantScreenSettings, setTenantScreenSettings] = useState({
    b2BShowCampaignButton: true,
    b2BViewUsdOnCurrencyDropDown: true,
    b2BViewEuroOnCurrencyDropDown: true,
    b2BCustomerInformationVisibility: true,
    b2BMobilePhoneVisibility: true,
    b2BTcknVisibility: false,
  });

  useEffect(() => {
    setPaymentGuid(props.location.search.split("d=")[1]);
    if (!activeProviderId) return;
    let currencies = ["TRY", "USD", "EUR"];

    //Param Pos
    if (activeProviderId === 889) {
      currencies = ["TRY"];
    }

    setCurrencyCodes(currencies);
    if (!tenantScreenSettings.b2BViewUsdOnCurrencyDropDown) {
      setCurrencyCodes((prev) => prev.filter((x) => x !== "USD"));
    }
    if (!tenantScreenSettings.b2BViewEuroOnCurrencyDropDown) {
      setCurrencyCodes((prev) => prev.filter((x) => x !== "EUR"));
    }
    setFieldsValue({ currencyCode: currencies[0] });

    if (!commissionOptions.data.isSelectableInstallmentTable) {
      getAvailableInstallments(activeProviderId);
    }
  }, [activeProviderId, tenantScreenSettings]);

  useEffect(() => {
    localStorage.clear();
    getConstantPaymentRequestInfo();
    setPaymentGuid(props.location.search.split("d=")[1]);
    getAvailableProviders(props.location.search.split("d=")[1]);
    getCommissionOptions(props.location.search.split("d=")[1]);
    if (props.data) {
      setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    if (commissionOptions.data.commissions.length > 0) {
      let bankIdFromBinCheck = bankIdFromBinCheckResult;
      const bankIdsFromCommissions = [
        ...new Set(
          commissionOptions.data.commissions.map((item) => item.bankId)
        ),
      ];
      RequestHandler.get(
        `/ConstantPaymentRequest/AvailableProviders?paymentGuid=${paymentGuid}${
          bankIdFromBinCheck ? "&bankIdFromBinCheck=" + bankIdFromBinCheck : ""
        }`
      ).then((response) => {
        if (response.success) {
          const filterWithCommissionBankIds = response.data.filter((x) =>
            bankIdsFromCommissions.includes(x.id)
          );
          setAvailableProviders({
            data: filterWithCommissionBankIds,
            loading: false,
          });
          setActiveProviderId(filterWithCommissionBankIds?.at(0)?.id);
          if (filterWithCommissionBankIds?.at(0)?.id) {
            getAvailableInstallments(
              filterWithCommissionBankIds?.at(0)?.id,
              commissionOptions.data.commissions
            );
          }
        } else {
          setAvailableProviders({ ...availableProviders, loading: false });
        }
      });
    }
  }, [commissionOptions]);

  const getAvailableProviders = (value) => {
    RequestHandler.get(
      `/ConstantPaymentRequest/AvailableProviders?paymentGuid=${value}`
    ).then((response) => {
      if (response.success) {
        setAvailableProviders({
          data: response.data,
          loading: false,
        });
        setActiveProviderId(response.data?.at(0)?.id);
      } else {
        setAvailableProviders({ ...availableProviders, loading: false });
      }
    });
  };

  const getCommissionOptions = (
    value,
    bankIdFromBinCheck,
    cardKindFromBinCheck,
    amount,
    paymentSetId
  ) => {
    let queryString = `?paymentGuid=${value}`;

    if (amount !== null && amount !== undefined) {
      queryString += `${queryString ? "&" : "?"}amount=${amount}`;
    }

    if (bankIdFromBinCheck && firmId) {
      queryString += `&bankIdFromBinCheck=${bankIdFromBinCheck}&cardKindFromBinCheck=${cardKindFromBinCheck}`;
    } else if (bankIdFromBinCheck && queryString != "") {
      queryString += `&bankIdFromBinCheck=${bankIdFromBinCheck}&cardKindFromBinCheck=${cardKindFromBinCheck}`;
    } else if (bankIdFromBinCheck && queryString == "") {
      queryString += `?bankIdFromBinCheck=${bankIdFromBinCheck}&cardKindFromBinCheck=${cardKindFromBinCheck}`;
    }

    if (paymentSetId) {
      queryString += `${queryString ? "&" : "?"}paymentSetId=${paymentSetId}`;
    }

    RequestHandler.get(
      `/ConstantPaymentRequest/CommissionOptions${queryString}`
    ).then((response) => {
      if (response.success) {
        setCommissionOptions({
          data: response.data,
          loading: false,
        });
      } else {
        setCommissionOptions({ ...commissionOptions, loading: false });
      }
    });
  };

  const getAvailableInstallments = (bankId, commissions) => {
    setAvailableInstallments({ ...availableInstallments, loading: true });

    RequestHandler.post(
      `/ConstantPaymentRequest/AvailableInstallments`,
      {
        bankId: bankId,
        paymentGuid: paymentGuid,
        commissions:
          commissions !== undefined && commissions !== null
            ? commissions.find((x) => x.bankId == bankId)
            : null,
        isUseCreditCardBinCheck: isUseCreditCardBinCheck,
      },
      false
    ).then((response) => {
      if (!response.success) {
        setAvailableInstallments({ ...availableInstallments, loading: false });
        setFieldsValue({ installmentCount: 1 });
        return;
      }

      const { installments, defaultInstallment } = response.data;
      setAvailableInstallments({ data: installments, loading: false });

      setFieldsValue({ installmentCount: defaultInstallment });
    });
  };

  const getConstantPaymentRequestInfo = () => {
    RequestHandler.post(
      `/ConstantPaymentRequest/GetByPaymentRequestId`,
      {
        PaymentRequestString: props.location.search.split("d=")[1],
      },
      false
    ).then((response) => {
      form.setFieldsValue({
        ...form.getFieldValue(),
        customerInformation: response.firmName,
      });
      setTenantName(response.tenantName);
      setUseAdditionalInformation(response.isPosTransactionUseAdditionalField);
      if (response.confidentialityAgreementPath) {
        setconfidentialAgreement(response.confidentialityAgreementPath);
      }
      if (response.salesAgreementPath) {
        setSalesAgreement(response.salesAgreementPath);
      }

      getTenantScreenSettings(response.tenantId);
      setIsUseCreditCardBinCheck(response.isUseCreditCardBinCheck);
      setIsUseB2BCurrencyExChange(response.isUseB2BCurrencyExChange);
      setTenantId(response.tenantId);
      setIsUseB2BViewCurrencyExchangeRate(response.b2BViewCurrencyExchangeRate);
      setB2bFilePath(response.b2BFilePath);

      if (response.isUseCreditCardBinCheck) {
        setUsePosCommissionTable(true);
        RequestHandler.get(
          `/ConstantPaymentRequest/CommissionOptions?paymentGuid=${
            props.location.search.split("d=")[1]
          }&requestForNoPayment=true`
        ).then((response) => {
          if (response.success) {
            setCommissionOptionsForBinCheckUsage({
              data: response.data,
              loading: false,
            });
          } else {
            setCommissionOptionsForBinCheckUsage({
              ...commissionOptions,
              loading: false,
            });
          }
        });
      }

      if (response.isPosTransactionUseAdditionalField) {
        RequestHandler.get(
          `/ConstantPaymentRequest/GetPaymentMethods?tenantId=${response.tenantId}`
        ).then((response) => {
          setPaymentMethodList({
            data: response.data,
            loading: false,
          });
        });
      }
      if (response.b2BViewCurrencyExchangeRate) {
        RequestHandler.get(
          `/PosCollection/GetCurrencies?tenantId=${response.tenantId}`
        ).then((currencyResponse) => {
          if (currencyResponse) {
            setViewCurrencyExchangeRates({
              data: {
                usd: currencyResponse?.find((item) => item.code === "USD")
                  ?.dailyValue,
                euro: currencyResponse?.find((item) => item.code === "EUR")
                  ?.dailyValue,
              },
            });
          }
        });
      }
    });
  };

  const onFinish = (values) => {
    let expireMonth, expireYear;

    if (values.expiration) {
      [expireMonth, expireYear] = values.expiration.split("/");
    }

    var bankIdCommissionIdWithInstallment = values.bankIdInstallment.split("/");
    values.bankId = bankIdCommissionIdWithInstallment[0];
    values.installmentCount = bankIdCommissionIdWithInstallment[3];
    values.cardType = bankIdCommissionIdWithInstallment[2];
    values.posCollectionCommissionDefinitionId =
      bankIdCommissionIdWithInstallment[1];

    RequestHandler.post(
      `/ConstantPaymentRequest/SalesRequest`,
      {
        holderName: values.holderName,
        cardNumber: values.cardNumber,
        cvv: values.cvv,
        expireMonth: expireMonth,
        expireYear: expireYear,
        amount: payableAmount,
        currencyCode: values.currencyCode,
        bankId: values.bankId,
        installmentCount: values.installmentCount,
        mobilePhone: values.MobilePhone,
        description: values.description,
        email: values.email,
        customerEmail: values.email,
        paymentGuid: paymentGuid,
        firmId: firmId != "" ? firmId : null,
        cardType: values.cardType,
        tckn: values.tckn,
        contractNumber: values.contractNumber,
        branchCode: values.branchCode,
        memberNumber: values.memberNumber,
        netAmount: values.amount,
        posCollectionCommissionDefinitionId:
          values.posCollectionCommissionDefinitionId,
        paymentMethod: selectedPaymentMethod?.name,
        paymentSetId: selectedPaymentMethod?.paymentSetId,
      },
      false
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        if (
          useUrlIframeBankIds?.includes(values.bankId) &&
          (response?.data?.html?.startsWith("http://") ||
            response?.data?.html?.startsWith("https://"))
        ) {
          setUrlIframe(true);
        }
        //fill html
        setPaymentModal({ visible: true, source: response.data.html });
        setPosCollectionTransactionId(response.data.posCollectionTransactionId);
        if (!isPaymentWithParams) {
          form.resetFields();
        }

        setFieldsValue({
          bankId: values.bankId,
        });

        if (props.onSuccess) props.onSuccess();
      }
    });
  };

  const onChangeActiveProvider = (value) => {
    setActiveProviderId(value);
  };

  const onFinishFailed = () => {
    setLoading(false);
  };

  const onChangeRadio = (radioVal, values) => {
    setRadioValue(radioVal);
    setFieldsValue(values);
  };

  const setFieldsValue = (values) => {
    const currentValues = form.getFieldsValue();
    const newValues = { ...currentValues, ...values };
    form.setFieldsValue(newValues);

    onFormValuesChange(values, newValues);
  };

  const onFormValuesChange = (changedValues, allValues) => {
    var activeCommissions = commissionOptions.data.commissions.find(
      (x) => x.bankId === allValues.bankId && !x.isVisaMasterCard
    );

    var installmentCount = allValues.installmentCount;
    if (allValues.bankIdInstallment) {
      var bankIdCommissionIdWithInstallment =
        allValues.bankIdInstallment.split("/");

      activeCommissions = commissionOptions.data.commissions.find(
        (x) =>
          x.id === bankIdCommissionIdWithInstallment[1] && !x.isVisaMasterCard
      );
      installmentCount = bankIdCommissionIdWithInstallment[3];
    }

    if (
      bankIdCommissionIdWithInstallment &&
      emailRequiredBankIds?.includes(bankIdCommissionIdWithInstallment[0])
    ) {
      setEmailRequired(true);
    } else {
      setEmailRequired(false);
    }

    if (!activeCommissions) {
      setPayableAmount(
        calculatePayableAmount(allValues.amount, 0, allValues.bankId, false)
      );

      setActiveCommissionRate(0);
      return;
    }
    const commissionRate =
      activeCommissions["commissionRate" + installmentCount];
    if (!(allValues.amount > 0 && commissionRate >= 0)) {
      setPayableAmount(
        calculatePayableAmount(allValues.amount, 0, allValues.bankId, false)
      );
      setActiveCommissionRate(commissionRate);
      return;
    }

    setPayableAmount(
      calculatePayableAmount(
        allValues.amount,
        commissionRate,
        allValues.bankId,
        activeCommissions["isCommissionFromDealer"]
      )
    );
    setActiveCommissionRate(commissionRate);
  };

  const calculatePayableAmount = (
    amount,
    commissionRate,
    bankId,
    isCommissionFromDealer
  ) => {
    const { useCommissionsForAvailableInstallment } = commissionOptions.data;
    let payableAmount = amount;
    if (useCommissionsForAvailableInstallment) {
      payableAmount = amount + (amount / 100) * commissionRate;
    }

    if (isCommissionFromDealer && useCommissionsForAvailableInstallment) {
      payableAmount = (amount / (100 - commissionRate)) * 100;
    }

    if (bankId == 856) {
      payableAmount = amount / ((100 - commissionRate) / 100);
    }

    return payableAmount;
  };

  const isExternalPaymentFormProvider = false;

  const afterPayment = () => {};

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const handleAmountInputBlur = (e) => {
    if (!(isUseCreditCardBinCheck && bankIdFromBinCheckResult === null)) {
      getCommissionOptions(
        paymentGuid,
        bankIdFromBinCheckResult,
        cardKindFromBinCheckResult,
        activeAmount,
        selectedPaymentMethod?.paymentSetId
      );
    }
  };

  const handleCardNumberChange = (e) => {
    if (!isUseCreditCardBinCheck) {
      return;
    }

    const inputValue = e.target.rawValue;

    if (inputValue.length <= 8) {
      setRequestBin(true);
    }

    if ((inputValue.length === 8 || inputValue.length === 16) && requestBin) {
      RequestHandler.post(
        `/PosCollection/CreditCardBinCheck`,
        {
          cardNumber: inputValue,
        },
        false
      ).then((response) => {
        if (response?.success) {
          setRequestBin(false);
          setBankIdFromBinCheckResult(response.data.bankId);
          setCardKindFromBinCheckResult(response.data.cardKind);
          getCommissionOptions(
            paymentGuid,
            response.data.bankId,
            response.data.cardKind,
            form.getFieldValue("amount"),
            selectedPaymentMethod?.paymentSetId
          );
        } else {
          getCommissionOptions();
        }
      });
    }
  };

  useEffect(() => {
    if (isNaN(payableAmount)) {
      setPayableAmount(0);
    } else {
      setPayableAmount(payableAmount);
    }
  }, [payableAmount]);

  useEffect(() => {
    if (availableProviders.data.length > 0) {
      const initialValue = availableProviders.data[0].id;
      onChangeActiveProvider(initialValue);
      setFieldsValue({ bankId: initialValue });
    }
  }, [availableProviders]);

  const handleAmountChange = () => {
    if (isUseB2BCurrencyExChange && typeof activeAmount === "number") {
      RequestHandler.post(
        `/PosCollection/GetPosCollectionTransactionExchangeAmounts`,
        {
          amount: activeAmount,
          currencyCode: activeCurrency,
          tenantId: tenantId,
        },
        false
      ).then((response) => {
        if (response?.success) {
          setCurrencyExchangeRates({
            data: {
              usdAmount: response.data.usdAmount,
              euroAmount: response.data.euroAmount,
              tlAmount: response.data.tlAmount,
            },
          });
        }
      });
    }
  };

  const combinedBlurFunctionForAmount = (e) => {
    handleAmountInputBlur(e);
    handleAmountChange();
  };

  useEffect(() => {
    if (isUseB2BCurrencyExChange) {
      RequestHandler.post(
        `/PosCollection/GetPosCollectionTransactionExchangeAmounts`,
        {
          amount: activeAmount,
          currencyCode: activeCurrency,
          tenantId: tenantId,
        },
        false
      ).then((response) => {
        if (response?.success) {
          setCurrencyExchangeRates({
            data: {
              usdAmount: response.data.usdAmount,
              euroAmount: response.data.euroAmount,
              tlAmount: response.data.tlAmount,
            },
          });
        }
      });
    }
  }, [activeCurrency]);

  useEffect(() => {
    if (useAdditionalInformation) {
      getCommissionOptions(
        paymentGuid,
        bankIdFromBinCheckResult,
        cardKindFromBinCheckResult,
        activeAmount,
        selectedPaymentMethod?.paymentSetId
      );

      clearRadioValue();
    }
  }, [selectedPaymentMethod]);

  const clearRadioValue = () => {
    setRadioValue(null);
    form.setFieldsValue({ bankIdInstallment: null });
  };

  const getTenantScreenSettings = (tenantId) => {
    RequestHandler.get(
      `/ConstantPaymentRequest/TenantScreenSettings?tenantId=${tenantId}&screenId=3`
    ).then((response) => {
      if (response.success) {
        setTenantScreenSettings(response.data);
      }
    });
  };

  return (
    <>
      <Row
        id="paymentArea"
        justify="center"
        align="middle"
        style={{
          paddingRight: "50px",
          paddingLeft: "50px",
          paddingTop: "50px",
        }}
      >
        <Col span={24}>
          <Card
            className="gx-card"
            loading={availableProviders.loading || commissionOptions.loading}
          >
            {availableProviders.data.length > 0 ? (
              <Form
                {...formItemLayout}
                validateMessages={defaultValidateMessages}
                form={form}
                name="PaymentForm"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                labelAlign="left"
                onValuesChange={onFormValuesChange}
                fields={[{ name: "payableAmount", value: payableAmount }]}
              >
                <>
                  <div style={{ textAlign: "center" }}>
                    Ödemeyi Alan: <strong>{tenantName}</strong>
                  </div>

                  <Divider>Ödeme Bilgileri</Divider>

                  <Row justify="center">
                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="Tutar"
                        name="amount"
                        rules={[{ required: true }]}
                      >
                        <InputNumber
                          style={{ width: "100%" }}
                          decimalSeparator=","
                          precision={2}
                          min={0}
                          placeholder="0,00"
                          onChange={(value) => {
                            setActiveAmount(value);
                            form.setFieldsValue({ amount: value }); // Form değerini manuel olarak güncelle
                          }}
                          disabled={disabledAmount}
                          onBlur={combinedBlurFunctionForAmount}
                        />
                        <div style={{ marginTop: "10px" }}>
                          {currencyExchangeRates.data.usdAmount &&
                          currencyExchangeRates.data.euroAmount ? (
                            <div style={{ color: "#0047ca" }}>
                              {currencyExchangeRates.data.usdAmount} /{" "}
                              {currencyExchangeRates.data.euroAmount}
                            </div>
                          ) : currencyExchangeRates.data.euroAmount ? (
                            <div style={{ color: "#0047ca" }}>
                              {currencyExchangeRates.data.euroAmount}
                            </div>
                          ) : currencyExchangeRates.data.usdAmount ? (
                            <div style={{ color: "#0047ca" }}>
                              {currencyExchangeRates.data.usdAmount}
                            </div>
                          ) : null}
                        </div>
                        {currencyExchangeRates.data.tlAmount && (
                          <div style={{ marginTop: "10px" }}>
                            <div style={{ color: "#0047ca" }}>
                              {currencyExchangeRates.data.tlAmount}
                            </div>
                          </div>
                        )}

                        <div style={{ marginTop: "5px" }}>
                          {isUseB2BViewCurrencyExchangeRate ? (
                            <div style={{ color: "#0047ca" }}>
                              {"USD Kur : " +
                                ColumnHelper.renderDecimal(
                                  viewCurrencyExchangeRates.data?.usd
                                )}
                            </div>
                          ) : null}
                        </div>
                        <div style={{ marginTop: "5px" }}>
                          {isUseB2BViewCurrencyExchangeRate ? (
                            <div style={{ color: "#0047ca" }}>
                              {"EURO Kur : " +
                                ColumnHelper.renderDecimal(
                                  viewCurrencyExchangeRates.data?.euro
                                )}
                            </div>
                          ) : null}
                        </div>
                      </Form.Item>
                    </Col>

                    <Col xs={24} lg={6}>
                      <Form.Item
                        label="Para Birimi"
                        name="currencyCode"
                        initialValue={currencyCodes[0]}
                      >
                        <Select
                          onChange={(value) => {
                            setActiveCurrency(value);
                          }}
                        >
                          {currencyCodes.map((currencyCode) => (
                            <Select.Option
                              key={currencyCode}
                              value={currencyCode}
                            >
                              {currencyCode}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  {isExternalPaymentFormProvider &&
                    commissionOptions.data.posCollectionDescription && (
                      <Row
                        id="descriptionArea"
                        style={{ marginBottom: 12 }}
                        justify="center"
                      >
                        <Col xs={24} lg={12}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                commissionOptions.data.posCollectionDescription,
                            }}
                          />
                        </Col>
                      </Row>
                    )}

                  {!isExternalPaymentFormProvider && (
                    <>
                      <Row justify="center">
                        <Col xs={24}>
                          <PosSelectableInstallmentTable
                            data={commissionOptions.data}
                            amount={activeAmount}
                            loading={commissionOptions.loading}
                            onChange={onChangeRadio}
                            radioValue={radioValue}
                            filePath={b2bFilePath}
                            campaignButtonVisibility={
                              tenantScreenSettings.b2BShowCampaignButton
                            }
                          />
                        </Col>
                      </Row>

                      {commissionOptions.data.posCollectionDescription && (
                        <Row
                          id="descriptionArea"
                          style={{ marginBottom: 12 }}
                          justify="center"
                        >
                          <Col xs={24} lg={12}>
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  commissionOptions.data
                                    .posCollectionDescription,
                              }}
                            />
                          </Col>
                        </Row>
                      )}

                      <Divider>Kart Bilgileri</Divider>

                      <Row justify="center">
                        <Col xs={24} lg={12}>
                          <Form.Item
                            label="Kart Üzerindeki İsim"
                            name="holderName"
                            rules={[{ required: true }]}
                          >
                            <Input placeholder="Ad Soyad" />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row justify="center">
                        <Col xs={24} lg={12}>
                          <Form.Item
                            label="Kart Numarası"
                            name="cardNumber"
                            valuePropName="rawValue"
                            rules={[
                              { required: true },
                              {
                                min: 15,
                                max: 16,
                              },
                            ]}
                          >
                            <Cleave
                              className="ant-input"
                              placeholder="0000 0000 0000 0000"
                              options={{
                                creditCard: true,
                                onCreditCardTypeChanged: (type) =>
                                  setCreditCardType(type),
                              }}
                              onChange={handleCardNumberChange}
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row justify="center">
                        <Col xs={24} lg={6}>
                          <Form.Item
                            label="Son Kullanma Tarihi"
                            name="expiration"
                            rules={[{ required: true }]}
                          >
                            <Cleave
                              className="ant-input"
                              placeholder="AA/YY"
                              options={{
                                date: true,
                                datePattern: ["m", "y"],
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} lg={6}>
                          <Form.Item
                            label="Güvenlik Kodu"
                            name="cvv"
                            rules={[{ required: true }]}
                          >
                            <Cleave
                              className="ant-input"
                              placeholder="CVV"
                              options={{
                                blocks: [4],
                                numericOnly: true,
                              }}
                              type="password"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}
                </>

                <Divider>Müşteri Bilgileri</Divider>

                <Row justify="center">
                  <Col
                    xs={tenantScreenSettings.b2BMobilePhoneVisibility ? 12 : 24}
                    lg={tenantScreenSettings.b2BMobilePhoneVisibility ? 6 : 12}
                    hidden={
                      !tenantScreenSettings.b2BCustomerInformationVisibility
                    }
                  >
                    <Form.Item
                      label="Müşteri Bilgisi"
                      name="customerInformation"
                      rules={[{ required: true }]}
                    >
                      <Input placeholder="Müşteri Bilgisi" />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={12}
                    lg={6}
                    hidden={!tenantScreenSettings.b2BMobilePhoneVisibility}
                  >
                    <Form.Item
                      label="Cep Numarası"
                      name="MobilePhone"
                      rules={[
                        {
                          required:
                            tenantScreenSettings.b2BMobilePhoneVisibility
                              ? true
                              : false,
                          min: 12,
                          message: "Telefon numarasını eksiksiz giriniz.",
                        },
                      ]}
                    >
                      <PhoneInput
                        inputStyle={{ width: "100%" }}
                        country="tr"
                        masks={{ tr: "(...) ...-..-.." }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {useAdditionalInformation ? (
                  <>
                    <Row justify="center">
                      <Col xs={9} lg={6}>
                        <Form.Item
                          label="TC Kimlik Numarası"
                          name="tckn"
                          rules={[
                            {
                              required: true,
                              min: 11,
                              message:
                                "TC Kimlik Numarası 11 Karakter Olmalıdır.",
                            },
                          ]}
                        >
                          <Input
                            placeholder="TC Kimlik Numarası"
                            type="number"
                            onKeyDown={(evt) =>
                              evt.key === "e" && evt.preventDefault()
                            }
                            maxLength="11"
                            onInput={maxLengthCheck}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={15} lg={6}>
                        <Form.Item
                          label="Sözleşme Numarası"
                          name="contractNumber"
                          rules={[
                            {
                              required: true,
                              min: 6,
                              message:
                                "Sözleşme numarası 6 Karakter Olmalıdır.",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Sözleşme Numarası"
                            type="number"
                            maxLength="6"
                            onInput={maxLengthCheck}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row justify="center">
                      <Col xs={15} lg={6}>
                        <Form.Item
                          label="Şube Adı/Kodu"
                          name="branchCode"
                          rules={[{ required: true }]}
                        >
                          <Input
                            placeholder="Şube Adı/Kodu"
                            maxLength="50"
                            onInput={maxLengthCheck}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={9} lg={6}>
                        <Form.Item label="Ek Alan" name="memberNumber">
                          <Input placeholder="Ek Alan" />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row justify="center">
                      <Col xs={15} lg={6}>
                        <Form.Item
                          label="Ödeme Şekli"
                          name="paymentMethod"
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Select
                            allowClear
                            placeholder="Ödeme Şekli"
                            onChange={(value, option) => {
                              setSelectedPaymentMethod(option);
                            }}
                          >
                            {paymentMethodList.data.map((item) => (
                              <Select.Option
                                key={item.id}
                                value={item.id}
                                name={item.name}
                                paymentSetId={item.paymentSetId}
                              >
                                {`${item.name}`}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={9} lg={6}></Col>
                    </Row>
                  </>
                ) : tenantScreenSettings.b2BTcknVisibility ? (
                  // useAdditionalInformation false ve tenantScreenSettings.b2BTcknVisibility true olduğunda sadece TCKN göster
                  <>
                    <Row justify="center">
                      <Col xs={12} lg={6}>
                        <Form.Item
                          label="TC Kimlik Numarası"
                          name="tckn"
                          rules={[
                            {
                              min: 11,
                              message:
                                "TC Kimlik Numarası 11 Karakter Olmalıdır.",
                            },
                          ]}
                        >
                          <Input
                            placeholder="TC Kimlik Numarası"
                            type="number"
                            onKeyDown={(evt) =>
                              evt.key === "e" && evt.preventDefault()
                            }
                            maxLength="11"
                            onInput={maxLengthCheck}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={12} lg={6}></Col>
                    </Row>
                  </>
                ) : null}
                <Row justify="center">
                  <Col xs={24} lg={6}>
                    <Form.Item
                      label="Email"
                      name="email"
                      hidden={isPaymentWithParams}
                      rules={[{ required: emailRequired, type: "email" }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={6}>
                    <Form.Item
                      label="Açıklama"
                      name="description"
                      rules={[{ required: isPaymentWithParams ? false : true }]}
                      hidden={isPaymentWithParams}
                    >
                      <TextArea rows={4} />
                    </Form.Item>
                  </Col>
                </Row>

                <PosCollectionAmountSummary
                  payableAmount={payableAmount}
                  activeAmount={activeAmount}
                  commissionRate={activeCommissionRate}
                />

                <Row justify="center">
                  <Col xs={24} lg={8}>
                    <Form.Item
                      name="agreement"
                      valuePropName="checked"
                      rules={[
                        {
                          required: true,
                          message: "Sözleşmeleri kabul etmeniz gerekmektedir.",
                        },
                      ]}
                    >
                      <Checkbox>
                        <a href={confidentialAgreement} target="_blank">
                          Gizlilik
                        </a>{" "}
                        ve{" "}
                        <a href={salesAgreement} target="_blank">
                          Tüketici Hakları
                        </a>{" "}
                        sözleşmelerini okudum, onaylıyorum.
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={4} style={{ textAlign: "right" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      onClick={() => setLoading(true)}
                      loading={loading}
                    >
                      {payableAmount > 0
                        ? `(${ColumnHelper.renderDecimal(payableAmount)}) `
                        : undefined}
                      Öde
                    </Button>
                  </Col>
                </Row>
              </Form>
            ) : (
              "Firmanızın tanımlı bir ödeme sağlayıcısı bulunmuyor."
            )}
          </Card>
          {!usePosCommissionTable &&
            !commissionOptions.loading &&
            !commissionOptions.data.isSelectableInstallmentTable &&
            commissionOptions.data.commissions.length > 0 && (
              <PosCommissionTable
                data={commissionOptions.data}
                amount={activeAmount}
                loading={commissionOptions.loading}
              />
            )}

          {usePosCommissionTable && (
            <PosCommissionTable
              data={commissionOptionsForBinCheckUsage.data}
              amount={activeAmount}
              loading={commissionOptionsForBinCheckUsage.loading}
            />
          )}
          <Footer>
            <div className="gx-layout-footer-content">
              {Screen.screen === 0 ? (
                <>
                  <span>{footerText}</span>
                  <img
                    src={require("../assets/images/paymentSymbols.png")}
                    alt="PaymentSymbols"
                    title="PaymentSymbols"
                    style={{
                      width: "100%",
                      maxWidth: "450px",
                      marginLeft: "500px",
                    }}
                  />
                </>
              ) : null}
            </div>
          </Footer>
        </Col>
      </Row>

      <Modal
        id="paymentModal"
        centered
        visible={paymentModal.visible}
        onCancel={() => {
          if (isPaymentWithParams) {
            afterPayment();
          }
          setPaymentModal({ ...paymentModal, visible: false });
          setUrlIframe(false);
        }}
        destroyOnClose={false}
        maskClosable={false}
        keyboard={false}
        width={600}
        footer={null}
      >
        {urlIframe ? (
          <iframe
            id="paymentFrame"
            ref={iframeRef}
            style={{ width: "100%", border: 0 }}
            src={paymentModal.source}
            scrolling="auto"
            onLoad={() => {
              const iframe = iframeRef.current;
              iframe.style.height = iframe.scrollWidth + 150 + "px";
            }}
          />
        ) : (
          <iframe
            id="paymentFrame"
            ref={iframeRef}
            style={{ width: "100%", border: 0 }}
            srcDoc={paymentModal.source}
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
            scrolling="auto"
            onLoad={() => {
              const iframe = iframeRef.current;
              iframe.style.height = iframe.scrollWidth + 150 + "px";
            }}
          />
        )}
      </Modal>
    </>
  );
};
export default ConstantPaymentPage;
